import React, { useRef, useEffect, useState } from "react"
import { motion, useMotionValue, useAnimation, useTransform } from "framer-motion"
import styled from "@emotion/styled"
import { DateDetailProps } from "./DateDetailModal";
import { DateDetaisBox } from "./DateDetailsBox";
import { rootStore } from "../StApp";

const StyledCard = styled(motion.div)`
  position: absolute;
`

const style: React.CSSProperties = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  backgroundColor: "rgb(228 155 229)",
  height: '70vh',
  width: '100%',

};

export const SwipeCard = (props: {
  data: DateDetailProps,
  upVote: () => boolean,
  downVote: () => void
}) => {

  // To move the card as the user drags the cursor
  const motionValue = useMotionValue(0);

  // To rotate the card as the card moves on drag
  const rotateValue = useTransform(motionValue, [-200, 200], [-25, 25]);

  // To decrease opacity of the card when swiped
  // on dragging card to left(-200) or right(200)
  // opacity gradually changes to 0
  // and when the card is in center opacity = 1
  // const opacityValue = useTransform(
  //     motionValue,
  //     [-180, -80, 0, 80, 180],
  //     [0, 0.6, 1, 0.6, 0]
  // );

  // Framer animation hook
  const animControls = useAnimation();

  function registerVote() {
    return props.upVote()

  }

  function registerDownVote() {
    props.downVote()
  }



  return (
    <motion.div
      className='absolute'
      drag='x'
      dragConstraints={{ left: -200, right: 200 }}
      animate={animControls}
      style={{
        overflow: 'scroll',
        
        borderRadius: 10,
        width: '90%',
        x: motionValue,
        rotate: rotateValue,
      }}
      dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
      onDragEnd={(event, info) => {
        let motionX = motionValue.get()
        // If the card is dragged only upto 150 on x-axis
        // bring it back to initial position
        // console.log(info.point.x)
        // console.log(motionX)
        if (Math.abs(motionX) <= 160) {
          animControls.start({ x: 0 });
        } else {
          // If card is dragged beyond 150
          // make it disappear
          // making use of ternary operator
          let isMotionBackward = motionX < 0
          animControls.start({ x: isMotionBackward ? info.point.x - 700 : info.point.x + 700 });
          if (isMotionBackward)
            registerDownVote()
          else {
            let result = registerVote()
            if (!result)
              animControls.start({ x: 0 });
          }

        }
      }}

    >
      <DateDetaisBox user={props.data.user} data={props.data} style={style} />
    </motion.div>
  )

}
